import { render, staticRenderFns } from "./setPlan.vue?vue&type=template&id=0b23e177&scoped=true&"
import script from "./setPlan.vue?vue&type=script&lang=ts&"
export * from "./setPlan.vue?vue&type=script&lang=ts&"
import style0 from "./setPlan.vue?vue&type=style&index=0&id=0b23e177&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b23e177",
  null
  
)

export default component.exports